import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import { Container, Icon, Option } from './components';
import './Select.scss';
/**
 * Select component for simple use cases, the usage of the AutoComplete component is recommended in most cases.
 */
export const Select = (props) => {
    const className = useClassName({ name: 'select', prefixed: true });
    return (_jsxs(Container, { children: [_jsx("select", { "data-testid": props.testId, ...props, className: className }), _jsx(Icon, {})] }));
};
Select.Option = Option;
